"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyIconButton = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip"));

const StyledTooltipContainer = (0, material_1.styled)("div")({
  display: "inline-block"
});

const SskyIconButton = props => {
  const renderIcon = () => {
    return react_1.default.createElement(material_1.IconButton, {
      id: props.id,
      className: props.className,
      color: props.color ? props.color !== "inherit" ? props.color : undefined : "secondary",
      disabled: props.disabled,
      onClick: props.onClick,
      onMouseEnter: props.onMouseEnter,
      "data-testid": props.dataTestId || `testId-${props.id}`,
      "data-tracking-id": props.dataTrackingId,
      size: props.size || "medium",
      sx: theme => ({
        margin: props.margin || theme.spacing(1)
      })
    }, props.icon);
  };

  return react_1.default.createElement(react_1.default.Fragment, null, props.tooltip && react_1.default.createElement(SskyTooltip_1.default, {
    title: props.tooltip,
    placement: props.tooltipPlacement,
    enterDelay: props.tooltipEnterDelay
  }, react_1.default.createElement(StyledTooltipContainer, null, renderIcon())), !props.tooltip && renderIcon());
};

exports.SskyIconButton = SskyIconButton;
SskyIconButton.defaultProps = {
  tooltipPlacement: "top"
};
exports.default = react_1.default.memo(SskyIconButton);